import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=5a2d0950&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=5a2d0950&prod&lang=scss&scoped=true"
import style1 from "./detail.vue?vue&type=style&index=1&id=5a2d0950&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_css-loader@6.11.0_webpack@5.106.0__lodash@4_fb6f2845f82ca867f83f204a66169969/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2d0950",
  null
  
)

export default component.exports